module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("50WkW"))).then(() => parcelRequire('d0iPb'));